import { type SVGProps, useId } from "react";

export function SubPartnersIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Sub-Partners</title>
			<path
				d="M7.33325 11.3332L8.66658 12.6665C8.79791 12.7978 8.95381 12.902 9.12539 12.9731C9.29697 13.0441 9.48087 13.0807 9.66658 13.0807C9.8523 13.0807 10.0362 13.0441 10.2078 12.9731C10.3794 12.902 10.5353 12.7978 10.6666 12.6665C10.7979 12.5352 10.9021 12.3793 10.9731 12.2077C11.0442 12.0361 11.0808 11.8522 11.0808 11.6665C11.0808 11.4808 11.0442 11.2969 10.9731 11.1253C10.9021 10.9537 10.7979 10.7978 10.6666 10.6665M9.33325 9.33318L10.9999 10.9998C11.2651 11.2651 11.6248 11.4141 11.9999 11.4141C12.375 11.4141 12.7347 11.2651 12.9999 10.9998C13.2651 10.7346 13.4141 10.3749 13.4141 9.99985C13.4141 9.62477 13.2651 9.26506 12.9999 8.99985L10.4133 6.41318C10.0382 6.03865 9.52992 5.82827 8.99992 5.82827C8.46992 5.82827 7.96159 6.03865 7.58658 6.41318L6.99992 6.99985C6.7347 7.26506 6.37499 7.41406 5.99992 7.41406C5.62485 7.41406 5.26513 7.26506 4.99992 6.99985C4.7347 6.73463 4.5857 6.37492 4.5857 5.99985C4.5857 5.62477 4.7347 5.26506 4.99992 4.99985L6.87325 3.12651C7.48141 2.51994 8.27452 2.13355 9.12701 2.0285C9.97951 1.92344 10.8427 2.10573 11.5799 2.54651L11.8933 2.73318C12.1771 2.90451 12.5146 2.96393 12.8399 2.89985L13.9999 2.66651M13.9999 1.99985L14.6666 9.33318H13.3333M1.99992 1.99985L1.33325 9.33318L5.66659 13.6665C5.9318 13.9317 6.29151 14.0807 6.66658 14.0807C7.04166 14.0807 7.40137 13.9317 7.66658 13.6665C7.9318 13.4013 8.0808 13.0416 8.0808 12.6665C8.0808 12.2914 7.9318 11.9317 7.66658 11.6665M1.99992 2.66651H7.33325"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
